import { styled } from 'styled-components';

export const ScrollbarsStyles = styled.div`
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #cfcfcf;
  }
  &::-webkit-scrollbar-thumb:hover {
    box-shadow: 8px 0 0 #cfcfcf inset;
    cursor: pointer;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: transparent;
  }
`;
